

















import { Cadastros } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import ChartDoughnut from "@/shared/components/chart-doughnut.vue";

@Component({
  components: { ChartDoughnut },
})
export default class GraficoCadastroDonut extends Vue {
  legenda = {
    title: "App",
    value: 0,
  };

  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly value!: Cadastros[];

  readonly labels = ["Aplicativo", "Site"];
  get dataSet(): Chart.ChartDataSets[] {
    const source = this.value ?? [];
    return [
      {
        backgroundColor: [
          "rgb(255, 99, 132)", //App
          "rgb(54, 162, 235)",
        ], //Site
        data: [
          source.length > 0
            ? source.map((x) => x.quantidadeApp ?? 0).reduce((a, b) => a + b)
            : 0, //Quantidade de aplicativo
          source.length > 0 //Quantidade de site
            ? source.map((x) => x.quantidadeSite ?? 0).reduce((a, b) => a + b)
            : 0,
        ],
      },
    ];
  }

  options: Chart.ChartOptions = {
    tooltips: {
      enabled: false,
      custom: (args) => {
        if (args?.dataPoints) {
          const source = this.value ?? [];
          switch (args.dataPoints[0].index) {
            default:
            case 0:
              this.legenda.title = "Aplicativo";
              this.legenda.value =
                source.length > 0
                  ? source
                      .map((x) => x.quantidadeApp ?? 0)
                      .reduce((a, b) => a + b)
                  : 0;
              break;
            case 1:
              this.legenda.title = "Site";
              this.legenda.value =
                source.length > 0
                  ? source
                      .map((x) => x.quantidadeSite ?? 0)
                      .reduce((a, b) => a + b)
                  : 0;
              break;
          }
        }
      },
    },
  };

  @Watch("value")
  onValueChange() {
    this.legenda.title = "Aplicativo";
    const source = this.value ?? [];
    this.legenda.value =
      source.length > 0
        ? source.map((x) => x.quantidadeApp ?? 0).reduce((a, b) => a + b)
        : 0;
  }

  mounted() {
    this.onValueChange();
  }
}
